var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs-wrap" },
    [
      _c(
        "ul",
        _vm._l(_vm.totalAccountList, function(user, index) {
          return _c(
            "li",
            {
              key: index,
              class:
                _vm.$store.getters.currentAuthUser &&
                _vm.$store.getters.currentAuthUser.corpUserId ===
                  user.corpUserId &&
                ((_vm.$route.path === "/ywtSystem" && user.systemType) ||
                  (_vm.$route.path !== "/ywtSystem" && !user.systemType))
                  ? "current"
                  : "",
              attrs: { title: user.corpName || user.name || user.username },
              on: {
                click: function($event) {
                  return _vm.changeAccount(user)
                }
              }
            },
            [
              user.userStemFrom === -16 && !_vm.isInDingTalk
                ? _c("img", {
                    attrs: {
                      src: _vm.isCurrent(user)
                        ? "/images/icon/dingIcon-act.png"
                        : "/images/icon/dingIcon.png",
                      alt: "钉钉",
                      width: "20px"
                    }
                  })
                : _vm._e(),
              user.systemType === "ywt"
                ? [
                    _c("img", {
                      staticStyle: { "max-height": "25px" },
                      attrs: {
                        src: require("../../static/images/ywt_logo.png"),
                        alt: ""
                      }
                    }),
                    _c("span", [
                      _vm._v(
                        "（" +
                          _vm._s(
                            (
                              user.corpName ||
                              user.name ||
                              user.username
                            ).substring(0, 5)
                          ) +
                          "）"
                      )
                    ])
                  ]
                : _c("span", [
                    _vm._v(_vm._s(user.corpName || user.name || user.username))
                  ])
            ],
            2
          )
        }),
        0
      ),
      _c("div", { staticClass: "pad-bom" }),
      _c("goto-auth", {
        attrs: { authDialog: _vm.authDialog },
        on: {
          "update:authDialog": function($event) {
            _vm.authDialog = $event
          },
          "update:auth-dialog": function($event) {
            _vm.authDialog = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c7e16bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c7e16bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/role-tab/index.vue
// module id = B5xS
// module chunks = 23 24 65 67 68 69 70 71 75 90 127 156